
import './App.css';
import React, { useEffect } from 'react';


function App() {

  const [url, setUrl] = React.useState('https://agendasimplificada.com.br/');

  useEffect(() => {

    const url = window.location.href; 
    const subdomain = url.split('subDomainWeb=')[1];  
    if (subdomain) {
      setUrl(`https://${subdomain}.agendasimplificada.com.br?ignoreValidacao=true`);
    } 
  }, []);


  
const styles = {
  body: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    margin: 0,
    backgroundImage: 'linear-gradient(to bottom, RGB(25, 118, 210), green)',
  },
  phoneFrame: {
    width: '375px', // Largura típica de um iPhone
    height: window.innerHeight - 50, // Altura típica de um iPhone
    border: '16px black solid',
    borderTop: '60px black solid',
    borderBottom: '60px black solid',
    borderRadius: '36px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
    position: 'relative',
    backgroundColor: 'white',
  },
  iframeContent: {
    width: '100%',
    height: '100%',
    border: 'none',
    // borderRadius: '20px',
  },
  phoneFrameBefore: {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '60px',
    height: '5px',
    background: '#333',
    borderRadius: '10px',
  },
  phoneFrameAfter: {
    content: '""',
    display: 'block',
    position: 'absolute',
    bottom: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '35%',
    height: '5px',
    background: '#333',
    borderRadius: '20px 20px 10px 10px',
  },
};



  return (
    // <div className="App">

    //   <div className='App-header'>

    //     <iframe
    //       className='iframe'
    //       src={url} />
    //   </div>

    // </div>

    <div style={styles.body}>
    <div style={styles.phoneFrame}>
      <iframe
        src={url}
        title="Web App"
        style={styles.iframeContent}
      ></iframe>
      <div style={styles.phoneFrameBefore}></div>
      <div style={styles.phoneFrameAfter}></div>
    </div>
  </div>
  );
}

export default App;
